document.addEventListener('DOMContentLoaded', function () {
  let currentButton = null;
  let isSeeking = false;

  // Mobile Detection & Touch Variables
  let isMobileDevice = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  let isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  let touchStartX = 0;
  let touchStartY = 0;
  let touchStartTime = 0;
  let lastTouchEnd = 0;

  // =========================================================
  // PERSISTENZ
  // =========================================================

  const STORAGE_KEY = 'globalPlayer.state.v1';
  const RESUME_MAX_AGE_MS = 1000 * 60 * 60; // 1 Stunde

  function loadStateRaw() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch {
      return null;
    }
  }

  function loadStateFresh() {
    const s = loadStateRaw();

    if (!s) return null;

    if (Date.now() - (s.savedAt || 0) > RESUME_MAX_AGE_MS) {
      return null;
    }

    return s;
  }

  function saveState(partial = {}) {
    try {
      const prev = loadStateRaw() || {};

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          ...prev,
          ...partial,
          savedAt: Date.now()
        })
      );
    } catch {}
  }

  // =========================================================
  // ELEMENTE
  // =========================================================

  const globalPlayer = document.getElementById('global-player');
  const globalAudio = document.getElementById('global-audio');
  const globalTitle = document.querySelector('.track-title');
  const globalInfo = document.querySelector('.track-info');
  const globalCover = document.getElementById('global-cover');
  const closeBtn = document.getElementById('player-close');
  const volumeSlider = document.getElementById('volume-slider');
  const progressBar = document.getElementById('player-progress-filled');
  const progressContainer = document.getElementById('player-progress');
  const globalPlayBtn = document.getElementById('player-toggle');
  const globalPlayIcon = globalPlayBtn?.querySelector('.play-icon');
  const globalPauseIcon = globalPlayBtn?.querySelector('.pause-icon');
  const progressThumb = document.getElementById('player-thumb');
  const currentTimeDisplay = document.getElementById('current-time');
  const totalTimeDisplay = document.getElementById('total-time');

  if (!globalPlayer || !globalAudio) {
    return;
  }

  // =========================================================
  // ZEIT FORMATIEREN
  // =========================================================

  function formatTime(seconds) {
    if (!Number.isFinite(seconds)) {
      return '0:00';
    }

    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);

    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  }

  // =========================================================
  // INITIALER PLAYER-STATUS
  // =========================================================

  const initialState = loadStateFresh();

  // Wenn der Player zuvor bewusst geschlossen wurde,
  // direkt sicherstellen, dass er unsichtbar bleibt.
  if (initialState?.isClosed === true) {
    globalPlayer.classList.remove('player-visible');
  }

  // =========================================================
  // LAUTSTÄRKE
  // =========================================================

  const defaultVolume = isMobileDevice ? 0.5 : 0.7;

  const initialVolume = Math.min(
    1,
    Math.max(
      0,
      initialState?.volume ?? defaultVolume
    )
  );

  if (volumeSlider) {
    volumeSlider.value = initialVolume;
  }

  globalAudio.volume = initialVolume;

  // =========================================================
  // MOBILE AUDIO CONTEXT
  // =========================================================

  let audioContextResumed = false;

  if (isMobileDevice && window.AudioContext) {
    const resumeAudioContext = () => {
      if (audioContextResumed) return;

      audioContextResumed = true;

      globalAudio.muted = false;

      document.removeEventListener('touchstart', resumeAudioContext);
      document.removeEventListener('click', resumeAudioContext);
    };

    document.addEventListener('touchstart', resumeAudioContext);
    document.addEventListener('click', resumeAudioContext);
  }

  // =========================================================
  // AUDIO METADATA
  // =========================================================

  globalAudio.addEventListener('loadedmetadata', function () {
    if (totalTimeDisplay) {
      totalTimeDisplay.textContent = formatTime(globalAudio.duration);
    }
  });

  // =========================================================
  // AUDIO ZEIT / PROGRESS
  // =========================================================

  globalAudio.addEventListener('timeupdate', function () {
    if (!isSeeking && globalAudio.duration > 0) {
      const percent =
        (globalAudio.currentTime / globalAudio.duration) * 100;

      if (progressBar) {
        progressBar.style.width = percent + '%';
      }

      if (progressThumb) {
        progressThumb.style.left = percent + '%';
      }

      if (currentTimeDisplay) {
        currentTimeDisplay.textContent =
          formatTime(globalAudio.currentTime);
      }
    }

    saveState({
      currentTime: globalAudio.currentTime
    });
  });

  // =========================================================
  // TRACK ENDE
  // =========================================================

  globalAudio.addEventListener('ended', function () {
    if (globalPlayIcon) {
      globalPlayIcon.style.display = 'inline';
    }

    if (globalPauseIcon) {
      globalPauseIcon.style.display = 'none';
    }

    if (currentButton) {
      currentButton.classList.remove('is-playing');

      currentButton
        .querySelector('.play-icon')
        ?.style.setProperty('display', 'inline');

      currentButton
        .querySelector('.pause-icon')
        ?.style.setProperty('display', 'none');
    }

    saveState({
      isPlaying: false,
      currentTime: 0
    });
  });

  // =========================================================
  // SEEK
  // =========================================================

  function seek(e) {
    const rect = progressContainer?.getBoundingClientRect();

    if (!rect) return;

    const clientX = e.touches
      ? e.touches[0].clientX
      : e.clientX;

    const offsetX = clientX - rect.left;

    const percent = Math.max(
      0,
      Math.min(
        1,
        offsetX / rect.width
      )
    );

    if (
      globalAudio.duration &&
      Number.isFinite(globalAudio.duration)
    ) {
      globalAudio.currentTime =
        percent * globalAudio.duration;
    }
  }

  // =========================================================
  // PROGRESS BAR TOUCH / MOUSE
  // =========================================================

  if (isTouch) {

    progressContainer?.addEventListener(
      'touchstart',
      function (e) {
        e.preventDefault();

        isSeeking = true;

        seek(e);

        touchStartTime = Date.now();
      },
      { passive: false }
    );

    document.addEventListener(
      'touchmove',
      function (e) {
        if (isSeeking) {
          e.preventDefault();
          seek(e);
        }
      },
      { passive: false }
    );

    document.addEventListener(
      'touchend',
      function (e) {
        if (isSeeking) {
          e.preventDefault();

          isSeeking = false;

          const now = Date.now();

          if (now - lastTouchEnd <= 300) {
            e.preventDefault();
          }

          lastTouchEnd = now;
        }
      },
      { passive: false }
    );

  } else {

    progressContainer?.addEventListener(
      'mousedown',
      function (e) {
        isSeeking = true;
        seek(e);
      }
    );

    document.addEventListener(
      'mousemove',
      function (e) {
        if (isSeeking) {
          seek(e);
        }
      }
    );

    document.addEventListener(
      'mouseup',
      function () {
        isSeeking = false;
      }
    );
  }

  // =========================================================
  // VOLUME
  // =========================================================

  volumeSlider?.addEventListener(
    'input',
    function () {
      globalAudio.volume =
        parseFloat(this.value);
    }
  );

  globalAudio.addEventListener(
    'volumechange',
    function () {
      saveState({
        volume: globalAudio.volume
      });
    }
  );

  // =========================================================
  // GLOBAL PLAY / PAUSE
  // =========================================================

  function togglePlayPause() {

    // Sobald der User bewusst wieder Play drückt,
    // gilt der Player nicht mehr als geschlossen.
    saveState({
      isClosed: false
    });

    globalPlayer.classList.add('player-visible');

    if (globalAudio.paused) {

      const playPromise =
        globalAudio.play();

      if (
        playPromise &&
        typeof playPromise.then === 'function'
      ) {

        playPromise
          .then(() => {

            if (globalPlayIcon) {
              globalPlayIcon.style.display = 'none';
            }

            if (globalPauseIcon) {
              globalPauseIcon.style.display = 'inline';
            }

            if (currentButton) {

              currentButton.classList.add(
                'is-playing'
              );

              currentButton
                .querySelector('.play-icon')
                ?.style.setProperty(
                  'display',
                  'none'
                );

              currentButton
                .querySelector('.pause-icon')
                ?.style.setProperty(
                  'display',
                  'inline'
                );
            }

            saveState({
              isPlaying: true,
              isClosed: false
            });
          })
          .catch((error) => {

            console.warn(
              'Audio play failed:',
              error
            );

            if (isMobileDevice) {
              alert(
                'Audio konnte nicht abgespielt werden. Bitte tippen Sie erneut.'
              );
            }
          });

      } else {

        if (globalPlayIcon) {
          globalPlayIcon.style.display = 'none';
        }

        if (globalPauseIcon) {
          globalPauseIcon.style.display = 'inline';
        }

        if (currentButton) {

          currentButton.classList.add(
            'is-playing'
          );

          currentButton
            .querySelector('.play-icon')
            ?.style.setProperty(
              'display',
              'none'
            );

          currentButton
            .querySelector('.pause-icon')
            ?.style.setProperty(
              'display',
              'inline'
            );
        }

        saveState({
          isPlaying: true,
          isClosed: false
        });
      }

    } else {

      globalAudio.pause();

      if (globalPlayIcon) {
        globalPlayIcon.style.display = 'inline';
      }

      if (globalPauseIcon) {
        globalPauseIcon.style.display = 'none';
      }

      if (currentButton) {

        currentButton.classList.remove(
          'is-playing'
        );

        currentButton
          .querySelector('.play-icon')
          ?.style.setProperty(
            'display',
            'inline'
          );

        currentButton
          .querySelector('.pause-icon')
          ?.style.setProperty(
            'display',
            'none'
          );
      }

      saveState({
        isPlaying: false
      });
    }
  }

  globalPlayBtn?.addEventListener(
    'click',
    togglePlayPause
  );

  // =========================================================
  // GLOBAL PLAY BUTTON TOUCH
  // =========================================================

  if (isTouch) {

    globalPlayBtn?.addEventListener(
      'touchstart',
      function (e) {
        e.preventDefault();

        this.classList.add('active');
      },
      { passive: false }
    );

    globalPlayBtn?.addEventListener(
      'touchend',
      function (e) {
        e.preventDefault();

        this.classList.remove('active');

        setTimeout(
          togglePlayPause,
          50
        );
      },
      { passive: false }
    );
  }

  // =========================================================
  // BUTTONS RESET
  // =========================================================

  function resetAllButtons() {

    document
      .querySelectorAll('.product-audio-trigger')
      .forEach(btn => {

        btn.classList.remove(
          'is-playing'
        );

        btn
          .querySelector('.play-icon')
          ?.style.setProperty(
            'display',
            'inline'
          );

        btn
          .querySelector('.pause-icon')
          ?.style.setProperty(
            'display',
            'none'
          );
      });

    if (globalPlayIcon) {
      globalPlayIcon.style.display =
        'inline';
    }

    if (globalPauseIcon) {
      globalPauseIcon.style.display =
        'none';
    }
  }

  // =========================================================
  // PLAYER STOP / CLOSE
  // =========================================================

  function stopGlobalAudio(
    hide = true,
    userClosed = false
  ) {

    globalAudio.pause();

    if (hide) {
      globalPlayer.classList.remove(
        'player-visible'
      );
    }

    resetAllButtons();

    currentButton = null;

    saveState({
      isPlaying: false,

      // WICHTIG:
      // Nur das bewusste Schließen über X
      // setzt isClosed auf true.
      ...(userClosed
        ? { isClosed: true }
        : {})
    });
  }

  // =========================================================
  // PRODUCT AUDIO BUTTONS
  // =========================================================

  function setupAudioButtons() {

    document
      .querySelectorAll('.product-audio-trigger')
      .forEach(button => {

        if (
          button.dataset.listenerAttached ===
          'true'
        ) {
          return;
        }

        function handleButtonClick() {

          const title =
            button.dataset.title;

          const bpm =
            button.dataset.bpm;

          const key =
            button.dataset.key;

          const src =
            button.dataset.src;

          const cover =
            button.dataset.cover;

          // Sobald ein Track bewusst geöffnet wird,
          // wird der Closed-Status aufgehoben.
          saveState({
            isClosed: false
          });

          if (
            isMobileDevice &&
            navigator.vibrate
          ) {
            navigator.vibrate(50);
          }

          // =================================================
          // GLEICHER TRACK
          // =================================================

          if (currentButton === button) {

            if (globalAudio.paused) {

              const playPromise =
                globalAudio.play();

              if (
                playPromise &&
                typeof playPromise.then ===
                  'function'
              ) {

                playPromise
                  .then(() => {

                    button.classList.add(
                      'is-playing'
                    );

                    button
                      .querySelector(
                        '.play-icon'
                      )
                      ?.style.setProperty(
                        'display',
                        'none'
                      );

                    button
                      .querySelector(
                        '.pause-icon'
                      )
                      ?.style.setProperty(
                        'display',
                        'inline'
                      );

                    if (globalPlayIcon) {
                      globalPlayIcon.style.display =
                        'none';
                    }

                    if (globalPauseIcon) {
                      globalPauseIcon.style.display =
                        'inline';
                    }

                    globalPlayer.classList.add(
                      'player-visible'
                    );

                    saveState({
                      isPlaying: true,
                      isClosed: false
                    });
                  })
                  .catch((error) => {

                    console.warn(
                      'Audio play failed:',
                      error
                    );

                    if (isMobileDevice) {

                      button.style.animation =
                        'shake 0.3s ease-in-out';

                      setTimeout(() => {
                        button.style.animation =
                          '';
                      }, 300);
                    }
                  });

              }

            } else {

              globalAudio.pause();

              button.classList.remove(
                'is-playing'
              );

              button
                .querySelector('.play-icon')
                ?.style.setProperty(
                  'display',
                  'inline'
                );

              button
                .querySelector('.pause-icon')
                ?.style.setProperty(
                  'display',
                  'none'
                );

              if (globalPlayIcon) {
                globalPlayIcon.style.display =
                  'inline';
              }

              if (globalPauseIcon) {
                globalPauseIcon.style.display =
                  'none';
              }

              saveState({
                isPlaying: false
              });
            }

            return;
          }

          // =================================================
          // NEUER TRACK
          // =================================================

          resetAllButtons();

          currentButton = button;

          if (globalTitle) {
            globalTitle.textContent =
              title || '';
          }

          if (globalInfo) {
            globalInfo.innerHTML =
              `⌚${bpm || '-'}BPM<br>🎵${key || '-'}`;
          }

          if (globalCover && cover) {
            globalCover.src = cover;
          }

          if (isMobileDevice) {
            globalAudio.preload =
              'metadata';
          }

          globalAudio.src = src;

          // WICHTIG:
          // Neuer Track = Player bewusst wieder geöffnet.
          saveState({
            src,
            title,
            bpm,
            key,
            cover,
            isPlaying: true,
            isClosed: false,
            currentTime: 0,
            volume: globalAudio.volume
          });

          const playPromise =
            globalAudio.play();

          if (
            playPromise &&
            typeof playPromise.then ===
              'function'
          ) {

            playPromise
              .then(() => {

                globalPlayer.classList.add(
                  'player-visible'
                );

                button.classList.add(
                  'is-playing'
                );

                button
                  .querySelector('.play-icon')
                  ?.style.setProperty(
                    'display',
                    'none'
                  );

                button
                  .querySelector('.pause-icon')
                  ?.style.setProperty(
                    'display',
                    'inline'
                  );

                if (globalPlayIcon) {
                  globalPlayIcon.style.display =
                    'none';
                }

                if (globalPauseIcon) {
                  globalPauseIcon.style.display =
                    'inline';
                }
              })
              .catch((error) => {

                console.warn(
                  'Auto-play blocked:',
                  error
                );

                if (isMobileDevice) {

                  globalPlayer.classList.add(
                    'player-visible'
                  );

                  if (globalPlayIcon) {
                    globalPlayIcon.style.display =
                      'inline';
                  }

                  if (globalPauseIcon) {
                    globalPauseIcon.style.display =
                      'none';
                  }

                  saveState({
                    isPlaying: false,
                    isClosed: false
                  });
                }
              });
          }
        }

        // ===================================================
        // MOBILE
        // ===================================================

        if (isTouch) {

          button.addEventListener(
            'touchstart',
            function (e) {

              e.preventDefault();

              touchStartX =
                e.touches[0].clientX;

              touchStartY =
                e.touches[0].clientY;

              touchStartTime =
                Date.now();

              this.classList.add(
                'active'
              );
            },
            { passive: false }
          );

          button.addEventListener(
            'touchend',
            function (e) {

              e.preventDefault();

              this.classList.remove(
                'active'
              );

              const touchDuration =
                Date.now() -
                touchStartTime;

              const touchEndX =
                e.changedTouches[0].clientX;

              const touchEndY =
                e.changedTouches[0].clientY;

              const deltaX =
                Math.abs(
                  touchEndX -
                    touchStartX
                );

              const deltaY =
                Math.abs(
                  touchEndY -
                    touchStartY
                );

              if (
                touchDuration < 500 &&
                deltaX < 10 &&
                deltaY < 10
              ) {
                handleButtonClick.call(
                  this
                );
              }
            },
            { passive: false }
          );

        } else {

          button.addEventListener(
            'click',
            handleButtonClick
          );
        }

        button.dataset.listenerAttached =
          'true';
      });
  }

  // =========================================================
  // CLOSE BUTTON
  // =========================================================

  function handlePlayerClose() {

    // Das ist ein bewusstes Schließen.
    // Deshalb isClosed = true.
    stopGlobalAudio(
      true,
      true
    );
  }

  if (isTouch) {

    closeBtn?.addEventListener(
      'touchstart',
      function (e) {

        e.preventDefault();

        this.classList.add(
          'active'
        );
      },
      { passive: false }
    );

    closeBtn?.addEventListener(
      'touchend',
      function (e) {

        e.preventDefault();

        this.classList.remove(
          'active'
        );

        handlePlayerClose();
      },
      { passive: false }
    );

  } else {

    closeBtn?.addEventListener(
      'click',
      function () {
        handlePlayerClose();
      }
    );
  }

  // =========================================================
  // SHOPIFY MUTATION OBSERVER
  // =========================================================

  function observeShopifyChanges() {

    const target =
      document.querySelector('main');

    if (!target) return;

    const observer =
      new MutationObserver(() => {

        setupAudioButtons();

        // Zusätzliche Sicherheit:
        // Wenn der Player geschlossen wurde,
        // darf Shopify ihn durch DOM-Änderungen
        // nicht wieder sichtbar machen.
        const state =
          loadStateFresh();

        if (state?.isClosed === true) {
          globalPlayer.classList.remove(
            'player-visible'
          );
        }
      });

    observer.observe(
      target,
      {
        childList: true,
        subtree: true
      }
    );
  }

  setupAudioButtons();
  observeShopifyChanges();

  document.addEventListener(
    'shopify:section:load',
    function () {

      setupAudioButtons();

      const state =
        loadStateFresh();

      if (state?.isClosed === true) {
        globalPlayer.classList.remove(
          'player-visible'
        );
      }
    }
  );

  document.addEventListener(
    'shopify:section:reorder',
    function () {

      setupAudioButtons();

      const state =
        loadStateFresh();

      if (state?.isClosed === true) {
        globalPlayer.classList.remove(
          'player-visible'
        );
      }
    }
  );

  // =========================================================
  // STATE WIEDERHERSTELLEN
  // =========================================================

  async function tryResumeFromState() {

    const s =
      loadStateFresh();

    if (!s) {
      return;
    }

    // =======================================================
    // DER ENTSCHEIDENDE FIX:
    //
    // Wenn der User den Player geschlossen hat,
    // wird NICHT resumed und der Player bleibt unsichtbar.
    // =======================================================

    if (s.isClosed === true) {

      globalAudio.pause();

      globalPlayer.classList.remove(
        'player-visible'
      );

      resetAllButtons();

      return;
    }

    if (!s.src) {
      return;
    }

    if (globalTitle) {
      globalTitle.textContent =
        s.title || '';
    }

    if (globalInfo) {
      globalInfo.innerHTML =
        `⌚${s.bpm || '-'}BPM<br>🎵${s.key || '-'}`;
    }

    if (globalCover && s.cover) {
      globalCover.src =
        s.cover;
    }

    if (
      globalAudio.src !== s.src
    ) {
      globalAudio.src =
        s.src;
    }

    if (
      typeof s.volume ===
      'number'
    ) {

      globalAudio.volume =
        Math.min(
          1,
          Math.max(
            0,
            s.volume
          )
        );

      if (volumeSlider) {
        volumeSlider.value =
          globalAudio.volume;
      }
    }

    try {

      await new Promise(
        (resolve, reject) => {

          if (
            !isNaN(globalAudio.duration) &&
            globalAudio.duration > 0
          ) {
            resolve();
            return;
          }

          const timeout =
            setTimeout(() => {

              reject(
                new Error(
                  'Metadata loading timeout'
                )
              );

            }, isMobileDevice
              ? 5000
              : 3000);

          globalAudio.addEventListener(
            'loadedmetadata',
            () => {

              clearTimeout(
                timeout
              );

              resolve();

            },
            { once: true }
          );

          globalAudio.addEventListener(
            'error',
            () => {

              clearTimeout(
                timeout
              );

              reject(
                new Error(
                  'Audio loading failed'
                )
              );

            },
            { once: true }
          );
        }
      );

    } catch (error) {

      console.warn(
        'Failed to load audio metadata:',
        error
      );

      if (isMobileDevice) {
        return;
      }
    }

    if (
      typeof s.currentTime ===
        'number' &&
      s.currentTime > 0 &&
      Number.isFinite(
        globalAudio.duration
      )
    ) {

      globalAudio.currentTime =
        Math.min(
          s.currentTime,
          Math.max(
            0,
            globalAudio.duration -
              0.25
          )
        );
    }

    // Nur sichtbar machen,
    // wenn er NICHT geschlossen wurde.
    globalPlayer.classList.add(
      'player-visible'
    );

    // =======================================================
    // DESKTOP AUTO RESUME
    // =======================================================

    if (
      s.isPlaying &&
      !isMobileDevice
    ) {

      try {

        await globalAudio.play();

        if (globalPlayIcon) {
          globalPlayIcon.style.display =
            'none';
        }

        if (globalPauseIcon) {
          globalPauseIcon.style.display =
            'inline';
        }

      } catch {

        if (globalPlayIcon) {
          globalPlayIcon.style.display =
            'inline';
        }

        if (globalPauseIcon) {
          globalPauseIcon.style.display =
            'none';
        }
      }

    } else {

      if (globalPlayIcon) {
        globalPlayIcon.style.display =
          'inline';
      }

      if (globalPauseIcon) {
        globalPauseIcon.style.display =
          'none';
      }
    }
  }

  tryResumeFromState();

  // =========================================================
  // PAGE HIDE
  // =========================================================

  window.addEventListener(
    'pagehide',
    () => {

      const existingState =
        loadStateRaw();

      saveState({
        currentTime:
          globalAudio.currentTime ||
          0,

        isPlaying:
          !globalAudio.paused,

        volume:
          globalAudio.volume,

        // WICHTIG:
        // Der aktuelle Closed-Status wird übernommen
        // und NICHT beim Seitenwechsel überschrieben.
        isClosed:
          existingState?.isClosed ??
          false
      });

      if (
        isMobileDevice &&
        !globalAudio.paused
      ) {
        globalAudio.pause();
      }
    }
  );

  // =========================================================
  // PAGE SHOW
  // =========================================================

  window.addEventListener(
    'pageshow',
    (e) => {

      setupAudioButtons();

      const state =
        loadStateFresh();

      // Auch beim Browser Back/Forward Cache
      // geschlossen halten.
      if (state?.isClosed === true) {

        globalAudio.pause();

        globalPlayer.classList.remove(
          'player-visible'
        );

        resetAllButtons();

        return;
      }

      if (
        e.persisted &&
        isMobileDevice
      ) {

        setTimeout(() => {

          if (!globalAudio.paused) {

            globalAudio.pause();

            resetAllButtons();

            saveState({
              isPlaying: false
            });
          }

        }, 100);
      }
    }
  );

  // =========================================================
  // MOBILE BATTERY / CONNECTION
  // =========================================================

  if (isMobileDevice) {

    document.addEventListener(
      'visibilitychange',
      () => {

        if (
          document.hidden &&
          !globalAudio.paused
        ) {

          setTimeout(
            () => {

              if (
                document.hidden &&
                !globalAudio.paused
              ) {

                globalAudio.pause();

                saveState({
                  isPlaying: false
                });
              }

            },
            30000
          );
        }
      }
    );

    if ('connection' in navigator) {

      const connection =
        navigator.connection;

      const isSlowConnection =
        connection.effectiveType ===
          'slow-2g' ||
        connection.effectiveType ===
          '2g' ||
        connection.saveData;

      if (isSlowConnection) {

        globalAudio.preload =
          'none';

        console.info(
          'Slow connection detected, audio preload disabled'
        );
      }

      connection.addEventListener(
        'change',
        () => {

          if (
            connection.effectiveType ===
              'slow-2g' &&
            !globalAudio.paused
          ) {

            console.warn(
              'Very slow connection - consider pausing audio'
            );
          }
        }
      );
    }

    if (
      'memory' in performance
    ) {

      const memoryInfo =
        performance.memory;

      if (
        memoryInfo.usedJSHeapSize /
          memoryInfo.jsHeapSizeLimit >
        0.8
      ) {

        console.warn(
          'High memory usage detected'
        );

        if (globalAudio.paused) {

          // Nur entfernen, wenn kein gespeicherter
          // Track aktiv wiederhergestellt werden muss.
          const state =
            loadStateFresh();

          if (
            !state?.src ||
            state?.isClosed
          ) {
            globalAudio.removeAttribute(
              'src'
            );

            globalAudio.load();
          }
        }
      }
    }
  }

  // =========================================================
  // ORIENTATION CHANGE
  // =========================================================

  if (isTouch) {

    window.addEventListener(
      'orientationchange',
      () => {

        setTimeout(
          () => {

            if (
              progressContainer
            ) {

              progressContainer.style.display =
                'none';

              progressContainer.offsetHeight;

              progressContainer.style.display =
                '';
            }

          },
          100
        );
      }
    );
  }
});